import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Chip,
} from '@mui/material';
import { Course } from '../types';

interface CourseCardProps {
  course: Course;
  onBuy: (courseId: number) => void;
}

const CourseCard: React.FC<CourseCardProps> = ({ course, onBuy }) => {
  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          height: 200,
          backgroundColor: 'primary.main',
          opacity: 0.8,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="h6" color="white" textAlign="center" px={2}>
          {course.title}
        </Typography>
      </Box>
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="body2" color="text.secondary" paragraph>
          {course.description}
        </Typography>
        <Box sx={{ mb: 2 }}>
          <Chip
            label={course.category}
            size="small"
            sx={{ mr: 1 }}
          />
          <Chip
            label={`${course.rating} ★`}
            size="small"
            color="primary"
          />
        </Box>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {course.duration} • {course.lessons} уроков
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Преподаватель: {course.instructor}
        </Typography>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" color="primary">
            {course.price} ₽
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => onBuy(course.id)}
          >
            Купить
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CourseCard; 